<template>
  <button class="repeat-btn" @click="onClick">
    <i v-if="random" class="material-icons shuffling">
      shuffle
    </i>
    <i v-else-if="repeat === 2" class="material-icons repeating">
      repeat_one
    </i>
    <i v-else-if="repeat === 1" class="material-icons repeating">
      repeat
    </i>
    <i v-else class="material-icons ">
      repeat
    </i>
  </button>
</template>
<script>
export default {
  name: 'PlayerRepeatBtn',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    repeat() {
      return this.$store.state.player.repeat
    },
    random() {
      return this.$store.state.player.random
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    onClick() {
      if (!this.random) {
        const newRepeatValue = (this.repeat + 1) % 3
        this.$store.commit('SET_REPEAT', newRepeatValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.repeat-btn {
  padding: 0; // clear btn style
  border: none;
  background-color: transparent;
  outline: none;
  color: $grey-9b;
  cursor: pointer;
  @media (hover:hover) {
    &:hover {
      color: $grey-7d;
    }
  }
  > .repeating {
    color: $theme-yellow;
    &.disabled {
      cursor: not-allowed;
      color: $grey-ec;
    }
  }
  > .shuffling {
    color: $theme-yellow;
    @media (hover:hover) {
      &:hover {
        cursor: default;
        color: $theme-yellow;
      }
    }
  }
}
</style>
